<template>
    <settings-page
        v-slot="{ formProcessing, onSubmit }"
        :show="show"
        class="show-settings-player"
    >
        <default-player-settings
            :show="show"
            :form-processing="formProcessing"
            @submit="onSubmit"
        />
        <call-to-action
            :show="show"
            :form-processing="formProcessing"
            @submit="onSubmit"
        />
    </settings-page>
</template>
<script>
import CallToAction from '@/components/Shows/Settings/CallToAction';
import DefaultPlayerSettings from '@/components/Shows/Settings/DefaultPlayerSettings';
import SettingsPage from './SettingsPage';

export default {
    components: {
        CallToAction,
        DefaultPlayerSettings,
        SettingsPage,
    },

    props: {
        show: {
            type: [Object, Boolean],
            default: () => ({}),
        },
    },
};
</script>
